import { LanguageCode } from '@mkp/shared/models';
import { PageCategory, PageCategoryOverride } from '@mkp/tracking/models';
import { urlToPageCategory } from './helpers/url-to-page-category';
import { urlToPageSection } from './helpers/url-to-page-section';

export type SuffixedPageCategory = Required<PageCategoryOverride>;

type BrowserContext = Pick<Window, 'location' | 'document'>;

interface GetPageCategoryOptions {
  pageReferrer: string;
  languageCode?: LanguageCode;
  windowRef: BrowserContext;
}

export const getPageCategory = ({
  pageReferrer,
  languageCode,
  windowRef,
}: GetPageCategoryOptions): PageCategory => {
  const url = `${windowRef.location.pathname}${windowRef.location.search}`;

  return {
    page_category: urlToPageCategory(url),
    page_section: urlToPageSection(url),
    page_language: languageCode,
    page_referrer: pageReferrer,
    page_location: windowRef.location.href,
    page_title: windowRef.document.title,
  };
};

export const getSuffixedPageCategory = (
  pageCategory: SuffixedPageCategory,
  suffix: string
): SuffixedPageCategory => ({
  page_category: `${pageCategory.page_category}${suffix.toLowerCase()}`,
  page_title: `${pageCategory.page_title}${suffix}`,
});
